import dayjs from "dayjs";

const DATE_ONLY_REGEX = /^(\d{4})-(\d{2})-(\d{2})/;

export const toExpenseDateOnly = (value) => {
  if (!value) {
    return "";
  }

  const asString = String(value).trim();
  const match = asString.match(DATE_ONLY_REGEX);

  if (match) {
    return `${match[1]}-${match[2]}-${match[3]}`;
  }

  const parsed = dayjs(value);
  if (!parsed.isValid()) {
    return "";
  }

  return parsed.format("YYYY-MM-DD");
};

export const formatExpenseDate = (value, outputFormat = "M/D/YYYY") => {
  const dateOnly = toExpenseDateOnly(value);

  if (!dateOnly) {
    return "N/A";
  }

  return dayjs(dateOnly).format(outputFormat);
};

export const getExpenseDateDayjs = (value) => {
  const dateOnly = toExpenseDateOnly(value);

  if (!dateOnly) {
    return null;
  }

  const parsed = dayjs(dateOnly);
  return parsed.isValid() ? parsed : null;
};
